import { CampaignStatusFilterValue } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/fetchFiltersList';

import { CampaignsTab } from 'store/models/campaignsDashboard';
import { AppliedCampaignsFilters, CampaignFilter } from 'store/models/campaignsFilters';

export const getAppliedCampaignsFiltersTotalCount = (appliedCampaignsFilters: AppliedCampaignsFilters): number => {
    return Object.values(appliedCampaignsFilters).reduce(
        (acc: number, filter: Set<string>) => acc + filter.size,
        0
    ) as number;
};

export const OVERLY_MASSIVE_FILTERS: CampaignFilter[] = [
    CampaignFilter.Areas,
    CampaignFilter.ProfessionalRoles,
    CampaignFilter.CreatedByUserIds,
];
export const MAX_CHECKBOX_SHOWN_COUNT = 6;

const MIN_CHECKBOX_COUNT_TO_SHOW_FILTER = 1;

const CAMPAIGN_STATUSES_BY_TAB: Partial<Record<CampaignsTab, string[]>> = {
    [CampaignsTab.All]: Object.values(CampaignStatusFilterValue),
    [CampaignsTab.Attention]: [CampaignStatusFilterValue.Active, CampaignStatusFilterValue.Inactive],
};

export const getAvailableCampaignStatuses = (tab: CampaignsTab): string[] => CAMPAIGN_STATUSES_BY_TAB[tab] || [];

export const getTabFilterList = (
    filterName: string,
    filterList: Record<string, string>,
    tab: CampaignsTab
): Record<string, string> => {
    if (filterName !== CampaignFilter.CampaignStatuses) {
        return filterList;
    }

    const availableStatuses = getAvailableCampaignStatuses(tab);
    return Object.fromEntries(Object.entries(filterList).filter(([status]) => availableStatuses.includes(status)));
};

export const needToShowFilter = (filterName: string, filterList: Record<string, string>): boolean => {
    const filterListLength = Object.keys(filterList).length;
    return (
        filterListLength > MIN_CHECKBOX_COUNT_TO_SHOW_FILTER ||
        ([CampaignFilter.CampaignStatuses, CampaignFilter.BudgetStatuses, CampaignFilter.ModerationStatuses].includes(
            filterName as CampaignFilter
        ) &&
            filterListLength > 0)
    );
};
